export function mixToMono(buffer: AudioBuffer): Float32Array {
  const length = buffer.length;
  const mono = new Float32Array(length);
  const channels = buffer.numberOfChannels;

  for (let ch = 0; ch < channels; ch++) {
    const data = buffer.getChannelData(ch);
    for (let i = 0; i < length; i++) {
      mono[i] += data[i] / channels;
    }
  }

  return mono;
}

export function adaptiveThreshold(
  values: Float32Array,
  multiplier: number,
  windowSize: number
): Float32Array {
  const thresholds = new Float32Array(values.length);

  for (let i = 0; i < values.length; i++) {
    const start = Math.max(0, i - windowSize);
    const end = Math.min(values.length, i + windowSize + 1);
    let sum = 0;
    for (let j = start; j < end; j++) {
      sum += values[j];
    }
    thresholds[i] = (sum / (end - start)) * multiplier;
  }

  return thresholds;
}
